import { useFormContext } from 'react-hook-form';

import { useAppSelector } from 'src/app/store/hooks';
import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

import { FormValues } from '../FormValues';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export const DefaultTripAddressField = () => {
  const { selectedPayer } = useAppSelector((state) => state.payer);
  const { clearErrors } = useFormContext<FormValues>();
  return (
    <FormFieldController name="default_trip_address">
      {({ field }) => {
        return (
          <FormField
            colSpan={12}
            label="Default Trip Address"
            type="location-typeahead"
            inputProps={{
              id: 'default_trip_address',
            }}
            value={field.value}
            onChange={(option: SelectOption) => {
              // setValue doesn't trigger revalidation for some reason
              clearErrors('default_trip_address');
              field.onChange({
                location: { place_id: option.value },
                label: option.label,
              });
            }}
            options={
              selectedPayer?.default_trip_address
                ? [
                    {
                      label:
                        selectedPayer.default_trip_address.location?.label ||
                        '',
                      value:
                        selectedPayer.default_trip_address.location?.place_id ||
                        '',
                    },
                  ]
                : []
            }
            error={
              field.errors?.default_trip_address?.place_id?.message &&
              !field.value?.place_id
                ? 'Please select a valid location'
                : undefined
            }
          />
        );
      }}
    </FormFieldController>
  );
};
